import { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { getUsers, postUsersAdmin } from '../utils/api';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Loading from './loading';

const drawerWidth = 240;

const Users = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [users, setUsers] = useState(null);

  function toggleAdmin(id) {
    const newUsers = [...users];
    const userIndex = newUsers.findIndex(u => u.id === id);
    
    if (userIndex !== -1) {
      newUsers[userIndex].isAdmin = !newUsers[userIndex].isAdmin;
      setUsers(newUsers); // Optimistic update

      postUsersAdmin(accessToken, newUsers[userIndex].id, newUsers[userIndex].name, newUsers[userIndex].email, newUsers[userIndex].isAdmin)
      .then(() => {
        getUsers(accessToken).then((data) => {
          setUsers(data);
        })
        .catch((error) => {
          console.warn(error);
          alert(error.toString());
        });
      })
      .catch((error) => {
        console.warn(error);
        alert(error.toString());
      });
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently().then((token) => setAccessToken(token));
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    if (!isLoading && accessToken) {
      getUsers(accessToken).then((data) => {
        setUsers(data);
      })
      .catch((error) => {
        console.warn(error);
        alert(error.toString());
      });
    }
  }, [isLoading, accessToken]);

  if (isLoading || !users) {
    return <Loading/>;
  }

  const sortedUsers = [...users].sort((a, b) => {
    if (a.isAdmin === b.isAdmin) return 0;
    return a.isAdmin ? -1 : 1;
  });

  return (
    <Box sx={{
      overflow: 'auto',
      maxHeight: (theme) => `calc(100vh - ${theme.spacing(14)})`,
      maxWidth: {
        xs: (theme) => `calc(100vw - ${theme.spacing(6)})`,
        md: (theme) => `calc(100vw - ${theme.spacing(6)} + ${drawerWidth}px)`
      }
    }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Admin</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedUsers.map(u => {
            return (
              <TableRow key={u.id}>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell><Switch disabled={u.isMe} checked={u.isAdmin} value="Admin" color="primary" onChange={() => toggleAdmin(u.id)} /></TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
}

export default Users;